import { Col, Form as BSForm, Row } from 'react-bootstrap';
import { Field, FieldArray, useFormikContext } from 'formik';
import ReactDatePicker from 'react-datepicker';
import SigniteToggle from '../../../../ui-elements/toggle-switch/signiteToggleSwitch';
import _ from 'lodash';
import { getErrorClass, getErrorMessage } from '../../../../../utils/errorUtils';
import LinkButton from '../../../../ui-elements/signite-link-button/linkButton';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from 'react';
import { MasterDataService } from '../../../../../services/masterDataService';
export const EducationQualificationForm = ({ handleChange, handleBlur, values, errors, touched, initialized }) => {
  const { setFieldValue } = useFormikContext();
  const [ugDegrees, setUgDegree] = useState(['']);
  const [pgDegrees, setPgDegree] = useState(['']);
  useEffect(() => {
    MasterDataService.getAllUgDegrees().then((data) => setUgDegree(['', ...data.data]));
    MasterDataService.getAllPgDegrees().then((data) => setPgDegree(['', ...data.data]));
  }, []);


  return (
    <div className="signite-form">
      <Row className="mb-3">
        <BSForm.Label>Do you have any Doctrate?</BSForm.Label>
        <BSForm.Group as={Col}>
          <div className="form-check form-check-inline">
            <Field
              type="radio"
              name="haveDoctorate"
              value="YES"
              className="form-check-input"
              checked={values.haveDoctorate === 'YES'}
            />
            <label htmlFor="haveDoctorate" className="form-check-label">
              YES
            </label>
          </div>
          <div className="form-check form-check-inline">
            <Field type="radio" name="haveDoctorate" value="NO" className="form-check-input" />
            <label htmlFor="haveDoctorate" className="form-check-label">
              NO
            </label>
          </div>
        </BSForm.Group>
      </Row>
      <FieldArray name="doctorates">
        {({ remove, push }) => (
          <>
            {values.haveDoctorate &&
              values.haveDoctorate === 'YES' &&
              values.doctorates &&
              values.doctorates.length > 0 &&
              values.doctorates.map((doctorate, index) => (
                <>
                  <Row className="mb-3">
                    <BSForm.Group as={Col} controlId="universityOrCollegeName">
                      <BSForm.Label>University/College Name*</BSForm.Label>
                      <BSForm.Control
                        name={`doctorates.${index}.doctorateUniversityOrCollegeName`}
                        value={doctorate.doctorateUniversityOrCollegeName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `doctorates.${index}.doctorateUniversityOrCollegeName`,
                          false
                        )}`}
                        type="text"
                      />
                      <span className="errorMessage">
                        {getErrorMessage(
                          errors,
                          touched,
                          `doctorates.${index}.doctorateUniversityOrCollegeName`,
                          false
                        )}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col} controlId="doctorateCourseType">
                      <BSForm.Label>Type of Course*</BSForm.Label>
                      <BSForm.Select
                        name={`doctorates.${index}.doctorateCourseType`}
                        value={doctorate.doctorateCourseType}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `doctorates.${index}.doctorateCourseType`,
                          false
                        )}`}
                      >
                        <option value="">--Select--</option>
                        <option value="FULL_TIME">Full Time</option>
                        <option value="PART_TIME"> Part Time</option>
                      </BSForm.Select>
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `doctorates.${index}.doctorateCourseType`, false)}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col} controlId={`doctorates.${index}.doctorateSpecialization`}>
                      <BSForm.Label>Degree*</BSForm.Label>
                      <BSForm.Control
                        type="text"
                        name={`doctorates.${index}.doctorateDegree`}
                        value={doctorate.doctorateDegree}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `doctorates.${index}.doctorateDegree`,
                          false,
                          false
                        )}`}
                      ></BSForm.Control>
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `doctorates.${index}.doctorateDegree`, false)}
                      </span>
                    </BSForm.Group>
                  </Row>
                  <Row className="mb-3">
                    <BSForm.Group as={Col} controlId={`doctorates.${index}.doctorateSpecialization`}>
                      <BSForm.Label>Specialisation*</BSForm.Label>
                      <BSForm.Control
                        type="text"
                        name={`doctorates.${index}.doctorateSpecialization`}
                        value={doctorate.doctorateSpecialization}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `doctorates.${index}.doctorateSpecialization`,
                          false
                        )}`}
                      ></BSForm.Control>
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `doctorates.${index}.doctorateSpecialization`, false)}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col} controlId={`doctorates.${index}.doctorateUniversityOrCollegeStartDate`}>
                      <BSForm.Label>Start Date</BSForm.Label>
                      <ReactDatePicker
                        name={`doctorates.${index}.doctorateUniversityOrCollegeStartDate`}
                        selected={
                          doctorate.doctorateUniversityOrCollegeStartDate
                            ? new Date(doctorate.doctorateUniversityOrCollegeStartDate)
                            : null
                        }
                        onChange={(val) => {
                          setFieldValue(`doctorates.${index}.doctorateUniversityOrCollegeStartDate`, val, true);
                        }}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `doctorates.${index}.doctorateUniversityOrCollegeStartDate`,
                          false
                        )}`}
                        dateFormat="yyyy"
                        maxDate={new Date()}
                        showYearPicker
                      />
                      <span className="errorMessage">
                        {getErrorMessage(
                          errors,
                          touched,
                          `doctorates.${index}.doctorateUniversityOrCollegeStartDate`,
                          false
                        )}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col} controlId={`doctorates.${index}.doctorateUniversityOrCollegeEndDate`}>
                      <BSForm.Label>End Date</BSForm.Label>
                      <ReactDatePicker
                        name={`doctorates.${index}.doctorateUniversityOrCollegeEndDate`}
                        selected={
                          doctorate.doctorateUniversityOrCollegeEndDate
                            ? new Date(doctorate.doctorateUniversityOrCollegeEndDate)
                            : null
                        }
                        onChange={(val) => {
                          setFieldValue(`doctorates.${index}.doctorateUniversityOrCollegeEndDate`, val, true);
                        }}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `doctorates.${index}.doctorateUniversityOrCollegeEndDate`,
                          false
                        )}`}
                        dateFormat="yyyy"
                        maxDate={new Date()}
                        showYearPicker
                      />
                      <span className="errorMessage">
                        {getErrorMessage(
                          errors,
                          touched,
                          `doctorates.${index}.doctorateUniversityOrCollegeEndDate`,
                          false
                        )}
                      </span>
                    </BSForm.Group>
                  </Row>
                  <Row>
                    <Col>
                      <LinkButton
                        onClick={() => remove(index)}
                        icon={faMinusCircle}
                        label="Remove this Doctorate"
                      ></LinkButton>
                    </Col>
                  </Row>
                  <hr style={{ marginTop: 32, marginBottom: 32 }} />
                </>
              ))}
            {values.haveDoctorate && values.haveDoctorate === 'YES' && (
              <Row className="mb-3">
                <Col>
                  <LinkButton
                    label="Add Doctorate"
                    onClick={() =>
                      push({
                        doctorateUniversityOrCollegeName: '',
                        doctorateCourseType: '',
                        doctorateSpecialization: '',
                        doctorateUniversityOrCollegeStartDate: null,
                        doctorateUniversityOrCollegeEndDate: null,
                      })
                    }
                  ></LinkButton>
                </Col>
              </Row>
            )}
          </>
        )}
      </FieldArray>

      <Row className="mb-3">
        <BSForm.Label>Do you have any Post Graduation Degree?</BSForm.Label>
        <BSForm.Group as={Col}>
          <div className="form-check form-check-inline">
            <Field type="radio" name="havePG" value="YES" className="form-check-input" />
            <label htmlFor="havePG" className="form-check-label">
              YES
            </label>
          </div>
          <div className="form-check form-check-inline">
            <Field type="radio" name="havePG" value="NO" className="form-check-input" />
            <label htmlFor="havePG" className="form-check-label">
              NO
            </label>
          </div>
        </BSForm.Group>
      </Row>
      <FieldArray name="pgLst">
        {({ remove, push }) => (
          <>
            {values.havePG &&
              values.havePG === 'YES' &&
              values.pgLst &&
              values.pgLst.length > 0 &&
              values.pgLst.map((pg, index) => (
                <>
                  <Row className="mb-3">
                    <BSForm.Group as={Col} controlId="pgUniversityOrCollegeName">
                      <BSForm.Label>University/College Name*</BSForm.Label>
                      <BSForm.Control
                        name={`pgLst.${index}.pgUniversityOrCollegeName`}
                        value={pg.pgUniversityOrCollegeName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `pgLst.${index}.pgUniversityOrCollegeName`,
                          initialized
                        )}`}
                        type="text"
                      />
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `pgLst.${index}.pgUniversityOrCollegeName`, initialized)}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col} controlId={`pgLst.${index}.pgCourseType`}>
                      <BSForm.Label>Type of Course*</BSForm.Label>
                      <BSForm.Select
                        name={`pgLst.${index}.pgCourseType`}
                        value={pg.pgCourseType}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `pgLst.${index}.pgCourseType`,
                          initialized
                        )}`}
                      >
                        <option value="">--Select--</option>
                        <option value="FULL_TIME">Full Time</option>
                        <option value="PART_TIME"> Part Time</option>
                      </BSForm.Select>
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `pgLst.${index}.pgCourseType`, initialized)}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col} controlId={`pgLst.${index}.pgSpecialization`}>
                      <BSForm.Label>Degree*</BSForm.Label>
                      <BSForm.Select
                        name={`pgLst.${index}.pgDegree`}
                        value={pg.pgDegree}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `pgLst.${index}.pgDegree`,
                          initialized
                        )}`}
                      >
                        {pgDegrees.map((degree) => (
                          <option value={degree}>{degree}</option>
                        ))}
                      </BSForm.Select>
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `pgLst.${index}.pgDegree`, initialized)}
                      </span>
                    </BSForm.Group>

                  </Row>
                  <Row className="mb-3">
                    <BSForm.Group as={Col} controlId={`pgLst.${index}.pgSpecialization`}>
                      <BSForm.Label>Specialisation*</BSForm.Label>
                      <BSForm.Control
                        type="text"
                        name={`pgLst.${index}.pgSpecialization`}
                        value={pg.pgSpecialization}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `pgLst.${index}.pgSpecialization`,
                          initialized
                        )}`}
                      ></BSForm.Control>
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `pgLst.${index}.pgSpecialization`, initialized)}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col} controlId={`pgLst.${index}.pgUniversityOrCollegeStartDate`}>
                      <BSForm.Label>Start Date</BSForm.Label>
                      <ReactDatePicker
                        name={`pgLst.${index}.pgUniversityOrCollegeStartDate`}
                        selected={
                          pg.pgUniversityOrCollegeStartDate ? new Date(pg.pgUniversityOrCollegeStartDate) : null
                        }
                        onChange={(val) => {
                          setFieldValue(`pgLst.${index}.pgUniversityOrCollegeStartDate`, val, true);
                        }}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `pgLst.${index}.pgUniversityOrCollegeStartDate`,
                          initialized
                        )}`}
                        dateFormat="yyyy"
                        maxDate={new Date()}
                        showYearPicker
                      />
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `pgLst.${index}.pgUniversityOrCollegeStartDate`, initialized)}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col} controlId={`pgLst.${index}.pgUniversityOrCollegeEndDate`}>
                      <BSForm.Label>End Date </BSForm.Label>
                      <ReactDatePicker
                        name={`pgLst.${index}.pgUniversityOrCollegeEndDate`}
                        selected={pg.pgUniversityOrCollegeEndDate ? new Date(pg.pgUniversityOrCollegeEndDate) : null}
                        onChange={(val) => {
                          setFieldValue(`pgLst.${index}.pgUniversityOrCollegeEndDate`, val, true);
                        }}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `pgLst.${index}.pgUniversityOrCollegeEndDate`,
                          initialized
                        )}`}
                        dateFormat="yyyy"
                        maxDate={new Date()}
                        showYearPicker
                      />
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `pgLst.${index}.pgUniversityOrCollegeEndDate`, initialized)}
                      </span>
                    </BSForm.Group>
                  </Row>
                  <Row className="mb-3">
                    <BSForm.Group as={Col} controlId="blank">
                      <BSForm.Label>CGPA/ Percentage</BSForm.Label>
                      <BSForm.Control
                        type="text"
                        name={`pgLst.${index}.pgCGPA`}
                        value={pg.pgCGPA}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `pgLst.${index}.pgCGPA`,
                          initialized
                        )}`}
                      ></BSForm.Control>
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `pgLst.${index}.pgCGPA`, initialized)}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col} controlId={`pgLst.${index}.pgRank`}>
                      <BSForm.Label>Rank</BSForm.Label>
                      <BSForm.Control
                        type="number"
                        name={`pgLst.${index}.pgRank`}
                        onChange={handleChange}
                        value={pg.pgRank}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `pgLst.${index}.pgRank`,
                          initialized
                        )}`}
                        min={0}
                      ></BSForm.Control>
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `pgLst.${index}.pgRank`, initialized)}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col} controlId=""></BSForm.Group>
                  </Row>
                  <Row className="mb-3">
                    <BSForm.Group as={Col} controlId="havePgBackLog">
                      <BSForm.Label>Do you have any Backpapers,Drop Year?</BSForm.Label>
                      <SigniteToggle
                        id={`pgLst.${index}.havePgBackLog`}
                        dataYES={'YES'}
                        dataNO={'NO'}
                        fieldInput={{
                          onChange: handleChange,
                          value: pg.havePgBackLog,
                        }}
                      />
                    </BSForm.Group>
                  </Row>
                  {pg.havePgBackLog && (
                    <Row className="mb-3">
                      <BSForm.Group as={Col} controlId={`pgLst.${index}.courseType`}>
                        <BSForm.Label>Start MM/YYYY</BSForm.Label>
                        <ReactDatePicker
                          name={`pgLst.${index}.pgBacklogStartDate`}
                          selected={pg.pgBacklogStartDate ? new Date(pg.pgBacklogStartDate) : null}
                          onChange={(val) => {
                            setFieldValue(`pgLst.${index}.pgBacklogStartDate`, val, true);
                          }}
                          onBlur={handleBlur}
                          className={`form-control ${getErrorClass(
                            errors,
                            touched,
                            `pgLst.${index}.pgBacklogStartDate`,
                            initialized
                          )}`}
                          dateFormat="yyyy"
                          maxDate={new Date()}
                          showYearPicker
                        />
                        <span className="errorMessage">
                          {getErrorMessage(errors, touched, `pgLst.${index}.pgBacklogStartDate`, initialized)}
                        </span>
                      </BSForm.Group>
                      <BSForm.Group as={Col} controlId="blank">
                        <BSForm.Label>End MM/YYYY</BSForm.Label>
                        <ReactDatePicker
                          name={`pgLst.${index}.pgBacklogEndDate`}
                          selected={pg.pgBacklogEndDate ? new Date(pg.pgBacklogEndDate) : null}
                          onChange={(val) => {
                            setFieldValue(`pgLst.${index}.pgBacklogEndDate`, val, true);
                          }}
                          onBlur={handleBlur}
                          className={`form-control ${getErrorClass(
                            errors,
                            touched,
                            `pgLst.${index}.pgBacklogEndDate`,
                            initialized
                          )}`}
                          dateFormat="yyyy"
                          maxDate={new Date()}
                          showYearPicker
                        />
                        <span className="errorMessage">
                          {getErrorMessage(errors, touched, `pgLst.${index}.pgBacklogEndDate`, initialized)}
                        </span>
                      </BSForm.Group>
                      <BSForm.Group as={Col} controlId="pgBacklogReason">
                        <BSForm.Label>Reason *</BSForm.Label>
                        <BSForm.Control
                          name={`pgLst.${index}.pgBacklogReason`}
                          value={pg.pgBacklogReason}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-control ${getErrorClass(
                            errors,
                            touched,
                            `pgLst.${index}.pgBacklogReason`,
                            initialized
                          )}`}
                        />
                        <span className="errorMessage">
                          {getErrorMessage(errors, touched, `pgLst.${index}.pgBacklogReason`, initialized)}
                        </span>
                      </BSForm.Group>
                    </Row>
                  )}
                  <Row>
                    <Col>
                      <LinkButton
                        onClick={() => remove(index)}
                        icon={faMinusCircle}
                        label="Remove this PG Degree"
                      ></LinkButton>
                    </Col>
                  </Row>
                  <hr style={{ marginTop: 32, marginBottom: 32 }} />
                </>
              ))}
            {values.havePG && values.havePG === 'YES' && (
              <Row className="mb-3">
                <Col>
                  <LinkButton
                    label="Add PG Degree"
                    onClick={() =>
                      push({
                        pgUniversityOrCollegeName: '',
                        pgCourseType: '',
                        pgDegree: '',
                        pgSpecialization: '',
                        pgUniversityOrCollegeStartDate: null,
                        pgUniversityOrCollegeEndDate: null,
                        pgCGPA: null,
                        pgBacklogStartDate: null,
                        pgBacklogEndDate: null,
                        pgBacklogReason: '',
                      })
                    }
                  ></LinkButton>
                </Col>
              </Row>
            )}
          </>
        )}
      </FieldArray>

      <Row className="mb-3">
        <BSForm.Label>Do you have any Graduation Degree?</BSForm.Label>
        <BSForm.Group as={Col}>
          <div className="form-check form-check-inline">
            <Field type="radio" name="haveGraduation" value="YES" className="form-check-input" />
            <label htmlFor="haveGraduation" className="form-check-label">
              YES
            </label>
          </div>
          <div className="form-check form-check-inline">
            <Field type="radio" name="haveGraduation" value="NO" className="form-check-input" />
            <label htmlFor="haveGraduation" className="form-check-label">
              NO
            </label>
          </div>
        </BSForm.Group>
      </Row>
      <FieldArray name="graduationLst">
        {({ remove, push }) => (
          <>
            {values.haveGraduation &&
              values.haveGraduation === 'YES' &&
              values.graduationLst &&
              values.graduationLst.length > 0 &&
              values.graduationLst.map((graduation, index) => (
                <>
                  <Row className="mb-3">
                    <BSForm.Group as={Col} controlId="graduationgraduationUniversityOrCollegeName">
                      <BSForm.Label>University/College Name*</BSForm.Label>
                      <BSForm.Control
                        name={`graduationLst.${index}.graduationUniversityOrCollegeName`}
                        value={graduation.graduationUniversityOrCollegeName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `graduationLst.${index}.graduationUniversityOrCollegeName`,
                          initialized
                        )}`}
                        type="text"
                      />
                      <span className="errorMessage">
                        {getErrorMessage(
                          errors,
                          touched,
                          `graduationLst.${index}.graduationUniversityOrCollegeName`,
                          initialized
                        )}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col} controlId="courseType">
                      <BSForm.Label>Type of Course*</BSForm.Label>
                      <BSForm.Select
                        name={`graduationLst.${index}.graduationCourseType`}
                        value={graduation.graduationCourseType}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `graduationLst.${index}.graduationCourseType`,
                          initialized
                        )}`}
                      >
                        <option value="">--Select--</option>
                        <option value="FULL_TIME">Full Time</option>
                        <option value="PART_TIME"> Part Time</option>
                      </BSForm.Select>
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `graduationLst.${index}.graduationCourseType`, initialized)}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col} controlId="blank">
                      <BSForm.Label>Degree*</BSForm.Label>
                      <BSForm.Select
                        name={`graduationLst.${index}.graduationDegree`}
                        value={graduation.graduationDegree}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `graduationLst.${index}.graduationDegree`,
                          initialized
                        )}`}
                      >
                        {ugDegrees.map((degree) => (
                          <option value={degree}>{degree}</option>
                        ))}
                      </BSForm.Select>

                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `graduationLst.${index}.graduationDegree`, initialized)}
                      </span>
                    </BSForm.Group>

                  </Row>
                  <Row className="mb-3">
                    <BSForm.Group as={Col} controlId="blank">
                      <BSForm.Label>Specialisation*</BSForm.Label>
                      <BSForm.Control
                        type="text"
                        name={`graduationLst.${index}.graduationSpecialization`}
                        value={graduation.graduationSpecialization}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `graduationLst.${index}.graduationSpecialization`,
                          initialized
                        )}`}
                      ></BSForm.Control>
                      <span className="errorMessage">
                        {getErrorMessage(
                          errors,
                          touched,
                          `graduationLst.${index}.graduationSpecialization`,
                          initialized
                        )}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col} controlId={`graduationLst.${index}.graduationUniversityOrCollegeStartDate`}>
                      <BSForm.Label>Start Date</BSForm.Label>
                      <ReactDatePicker
                        name={`graduationLst.${index}.graduationUniversityOrCollegeStartDate`}
                        selected={
                          graduation.graduationUniversityOrCollegeStartDate
                            ? new Date(graduation.graduationUniversityOrCollegeStartDate)
                            : null
                        }
                        onChange={(val) => {
                          setFieldValue(`graduationLst.${index}.graduationUniversityOrCollegeStartDate`, val, true);
                        }}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `graduationLst.${index}.graduationUniversityOrCollegeStartDate`,
                          initialized
                        )}`}
                        dateFormat="yyyy"
                        maxDate={new Date()}
                        showYearPicker
                      />
                      <span className="errorMessage">
                        {getErrorMessage(
                          errors,
                          touched,
                          `graduationLst.${index}.graduationUniversityOrCollegeStartDate`,
                          initialized
                        )}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col} controlId="graduationUniversityOrCollegeEndDate">
                      <BSForm.Label>End Date </BSForm.Label>
                      <ReactDatePicker
                        name={`graduationLst.${index}.graduationUniversityOrCollegeEndDate`}
                        selected={
                          graduation.graduationUniversityOrCollegeEndDate
                            ? new Date(graduation.graduationUniversityOrCollegeEndDate)
                            : null
                        }
                        onChange={(val) => {
                          setFieldValue(`graduationLst.${index}.graduationUniversityOrCollegeEndDate`, val, true);
                        }}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `graduationLst.${index}.graduationUniversityOrCollegeEndDate`,
                          initialized
                        )}`}
                        dateFormat="yyyy"
                        maxDate={new Date()}
                        showYearPicker
                      />
                      <span className="errorMessage">
                        {getErrorMessage(
                          errors,
                          touched,
                          `graduationLst.${index}.graduationUniversityOrCollegeEndDate`,
                          initialized
                        )}
                      </span>
                    </BSForm.Group>
                  </Row>
                  <Row className="mb-3">
                    <BSForm.Group as={Col} controlId="blank">
                      <BSForm.Label>CGPA/ Percentage</BSForm.Label>
                      <BSForm.Control
                        type="text"
                        name={`graduationLst.${index}.graduationCGPA`}
                        value={graduation.graduationCGPA}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `graduationLst.${index}.graduationCGPA`,
                          initialized
                        )}`}
                      ></BSForm.Control>
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `graduationLst.${index}.graduationCGPA`, initialized)}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col} controlId="graduationRank">
                      <BSForm.Label>Rank</BSForm.Label>
                      <BSForm.Control
                        type="number"
                        name={`graduationLst.${index}.graduationRank`}
                        onChange={handleChange}
                        value={graduation.graduationRank}
                        min={0}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `graduationLst.${index}.graduationRank`,
                          initialized
                        )}`}
                      ></BSForm.Control>
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `graduationLst.${index}.graduationRank`, initialized)}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col} controlId="blank"></BSForm.Group>
                  </Row>
                  <Row className="mb-3">
                    <BSForm.Group as={Col} controlId="haveGraduationBackLog">
                      <BSForm.Label>Do you have any Backpapers,Drop Year?</BSForm.Label>
                      <SigniteToggle
                        id={`graduationLst.${index}.haveGraduationBackLog`}
                        dataYES={'YES'}
                        dataNO={'NO'}
                        fieldInput={{
                          onChange: handleChange,
                          value: graduation.haveGraduationBackLog,
                        }}
                      />
                    </BSForm.Group>
                    <BSForm.Group as={Col} controlId="blank"></BSForm.Group>
                    <BSForm.Group as={Col} controlId="blank"></BSForm.Group>
                  </Row>
                  {graduation.haveGraduationBackLog && (
                    <Row className="mb-3">
                      <BSForm.Group as={Col} controlId="courseType">
                        <BSForm.Label>Start MM/YYYY</BSForm.Label>
                        <ReactDatePicker
                          name={`graduationLst.${index}.graduationBacklogStartDate`}
                          selected={
                            graduation.graduationBacklogStartDate
                              ? new Date(graduation.graduationBacklogStartDate)
                              : null
                          }
                          onChange={(val) => {
                            setFieldValue(`graduationLst.${index}.graduationBacklogStartDate`, val, true);
                          }}
                          onBlur={handleBlur}
                          className={`form-control ${getErrorClass(
                            errors,
                            touched,
                            `graduationLst.${index}.graduationBacklogStartDate`,
                            initialized
                          )}`}
                          dateFormat="yyyy"
                          maxDate={new Date()}
                          showYearPicker
                        />
                        <span className="errorMessage">
                          {getErrorMessage(
                            errors,
                            touched,
                            `graduationLst.${index}.graduationBacklogStartDate`,
                            initialized
                          )}
                        </span>
                      </BSForm.Group>
                      <BSForm.Group as={Col} controlId="blank">
                        <BSForm.Label>End MM/YYYY</BSForm.Label>
                        <ReactDatePicker
                          name={`graduationLst.${index}.graduationBacklogEndDate`}
                          selected={
                            graduation.graduationBacklogEndDate ? new Date(graduation.graduationBacklogEndDate) : null
                          }
                          onChange={(val) => {
                            setFieldValue(`graduationLst.${index}.graduationBacklogEndDate`, val, true);
                          }}
                          onBlur={handleBlur}
                          className={`form-control ${getErrorClass(
                            errors,
                            touched,
                            `graduationLst.${index}.graduationBacklogEndDate`,
                            initialized
                          )}`}
                          dateFormat="yyyy"
                          maxDate={new Date()}
                          showYearPicker
                        />
                        <span className="errorMessage">
                          {getErrorMessage(
                            errors,
                            touched,
                            `graduationLst.${index}.graduationBacklogEndDate`,
                            initialized
                          )}
                        </span>
                      </BSForm.Group>
                      <BSForm.Group as={Col} controlId="graduationBacklogReason">
                        <BSForm.Label>Reason *</BSForm.Label>
                        <BSForm.Control
                          name={`graduationLst.${index}.graduationBacklogReason`}
                          value={graduation.graduationBacklogReason}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-control ${getErrorClass(
                            errors,
                            touched,
                            `graduationLst.${index}.graduationBacklogReason`,
                            initialized
                          )}`}
                        />
                        <span className="errorMessage">
                          {getErrorMessage(
                            errors,
                            touched,
                            `graduationLst.${index}.graduationBacklogReason`,
                            initialized
                          )}
                        </span>
                      </BSForm.Group>
                    </Row>
                  )}
                  <Row>
                    <Col>
                      <LinkButton
                        onClick={() => remove(index)}
                        icon={faMinusCircle}
                        label="Remove this Graduation Degree"
                      ></LinkButton>
                    </Col>
                  </Row>
                  <hr style={{ marginTop: 32, marginBottom: 32 }} />
                </>
              ))}
            {values.haveGraduation && values.haveGraduation === 'YES' && (
              <Row className="mb-3">
                <Col>
                  <LinkButton
                    label="Add Graduation Degree"
                    onClick={() =>
                      push({
                        graduationUniversityOrCollegeName: '',
                        graduationCourseType: '',
                        graduationDegree: '',
                        graduationSpecialization: '',
                        graduationUniversityOrCollegeStartDate: null,
                        graduationUniversityOrCollegeEndDate: null,
                        graduationCGPA: null,
                        graduationBacklogStartDate: null,
                        graduationBacklogEndDate: null,
                        graduationBacklogReason: '',
                      })
                    }
                  ></LinkButton>
                </Col>
              </Row>
            )}
          </>
        )}
      </FieldArray>
    </div>
  );
};